const ServiceIcon11 = () => {
    return ( 
        <div>
            <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.2821 5.13906C25.3037 4.11747 26.0442 2.76936 26.1886 1.35693H31.2772L39.4152 6.78228L36.8584 15.3474L31.7083 11.8711L30.9286 11.3448V12.2855V34.6427H9.07143V12.2855V11.3448L8.29169 11.8711L3.14156 15.3474L0.584803 6.78228L8.72282 1.35693H13.8114C13.9558 2.76936 14.6963 4.11747 15.7179 5.13906C16.8595 6.28066 18.4088 7.07122 20 7.07122C21.5912 7.07122 23.1405 6.28066 24.2821 5.13906Z" fill="white" stroke="black"/>
            </svg>
        </div>
    );
}

export default ServiceIcon11;